/**
 * Which map feature ends up on top — and therefore which one a click selects.
 *
 * MapLibre draws layers in the order they are added and `queryRenderedFeatures`
 * returns them TOP FIRST, so `features[0]` in the map click handler is whatever
 * was added LAST. react-map-gl adds them in the order the components are
 * rendered, which means render order IS z-order IS click priority.
 *
 * `GET /api/lines` returns `ORDER BY created_at DESC` — newest first — so
 * rendering the array as it arrives puts the OLDEST line on top. Every line also
 * carries a 20px-wide invisible hit layer, so on the Island Garrison board the
 * imported Νήσος Μεγίστη Ακτογραμμή coastline sat above every line drawn since
 * and swallowed their clicks: clicking a freshly drawn intercept route selected
 * the coastline instead, and the route looked unclickable.
 *
 * Reversing gives newest-on-top, which is also what the sidebar list implies
 * (newest first) and what an operator expects of something they just drew.
 */

/** Newest last, so the newest feature renders on top and wins the click. */
export function topmostLast<T>(items: readonly T[]): T[] {
  return items.slice().reverse();
}
